import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from '@/components/ui/checkbox-field';
import {
  classificationKeys,
  getLocalizedClassificationLabel,
} from '../../../utils/verificationLabels';

interface ClassificationChecklistProps {
  selected: string[];
  onToggle: (key: string) => void;
}

const ClassificationChecklist: React.FC<ClassificationChecklistProps> = ({
  selected,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h6 className="revy-cjk mb-2 text-sm font-medium leading-[1.5]">
        {t('verification.table.classification')} (◎)
      </h6>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {classificationKeys.map((key) => (
          <CheckboxField
            key={key}
            checked={selected.includes(key)}
            onChange={() => onToggle(key)}
            label={getLocalizedClassificationLabel(t, key)}
          />
        ))}
      </div>
    </div>
  );
};

export default ClassificationChecklist;
